import styled from 'styled-components';

import { theme } from "../../../configuration";

const TextInput = styled.input`
  padding: 10px;
  width: calc(100% - 20px);
  max-width: 400px;
  border: 1px solid ${theme.colours.border};
  border-radius: 4px;
`;

export default TextInput;

